import { RouteRecordRaw } from 'vue-router';

const consumer: RouteRecordRaw[] = [
  {
    path: '/:i18nParamKey/system',
    name: 'System',
    component: () => import(/* webpackChunkName: "system" */ '@/layouts/system/System.vue'),
    children: [
      {
        path: '/:i18nParamKey/system/home',
        name: 'SystemHome',
        meta: {
          needAuth: true,
        },
        component: () => import(/* webpackChunkName: "system-home" */ '@/views/system/home/Home.vue'),
      },
      {
        path: '/:i18nParamKey/system/record-name',
        name: 'SystemRecordName',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "system-record-name" */ '@/views/system/record-name/RecordName.vue'
          ),
      },
      {
        path: '/:i18nParamKey/system/record-age',
        name: 'SystemRecordAge',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-record-age" */ '@/views/system/record-age/RecordAge.vue'),
      },
      {
        path: '/:i18nParamKey/system/welcome',
        name: 'SystemWelcome',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-welcome" */ '@/views/system/welcome/Welcome.vue'),
      },
      {
        path: '/:i18nParamKey/system/questionnaire',
        name: 'SystemQuestionnaire',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "system-questionnaire" */ '@/views/system/questionnaire/Questionnaire.vue'
          ),
      },
      {
        path: '/:i18nParamKey/system/analysing',
        name: 'SystemAnalysing',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-analysing" */ '@/views/system/analysing/Analysing.vue'),
      },
      {
        path: '/:i18nParamKey/system/result',
        name: 'SystemResult',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-result" */ '@/views/system/result/Result.vue'),
      },
      {
        path: '/:i18nParamKey/system/marketing',
        name: 'SystemMarketing',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-marketing" */ '@/views/system/marketing/Marketing.vue'),
      },
      {
        path: '/:i18nParamKey/system/share',
        name: 'SystemShare',
        meta: {
          needAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "system-share" */ '@/views/system/share/Share.vue'),
      },
    ],
  },
];

export default consumer;
